import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useState } from "react";

export type GameCardProps = {
  id: string | number;
  title: string;
  description: string;
  type: string;
  link: string;
  icon: React.ReactNode;
  className?: string;
};

const GameCard = ({
  title,
  description,
  type,
  link,
  icon,
  className = "",
}: GameCardProps) => {
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <div 
      className={`game-card bg-white rounded-xl overflow-hidden shadow-md transition-all duration-300 cursor-pointer ${
        isHovered ? "shadow-xl -translate-y-1" : ""
      } ${className}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Icon Container */}
      <div className="h-48 bg-amber-50 flex items-center justify-center relative overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-1/4 left-1/4 transform -translate-x-1/2 -translate-y-1/2 w-24 h-24 text-amber-500">
            <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full opacity-30">
              <path d="M12,2L4.5,20.29L5.21,21L12,18L18.79,21L19.5,20.29L12,2Z" />
            </svg>
          </div>
          <div className="absolute bottom-1/4 right-1/4 transform translate-x-1/2 translate-y-1/2 w-32 h-32 text-amber-500">
            <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full opacity-20">
              <path d="M12,8L15.5,13.5L13.5,13.5L13.5,20H10.5V13.5H8.5L12,8M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z" />
            </svg>
          </div>
        </div>
        
        {/* Central Icon with Animation */}
        <div className="relative w-32 h-32 z-10">
          <div className={`absolute inset-0 bg-amber-200 rounded-full ${isHovered ? "animate-pulse" : ""}`}></div>
          <div className="absolute inset-4 bg-white rounded-full flex items-center justify-center">
            {icon}
          </div>
        </div>
      </div>
      
      {/* Content */}
      <div className="p-6">
        <h3 className="text-xl font-bold text-amber-800 mb-2">{title}</h3>
        <p className="text-gray-700 mb-4">{description}</p>
        <div className="flex justify-between items-center">
          <span className="text-sm bg-amber-100 text-amber-800 px-3 py-1 rounded-full">{type}</span>
          <Link 
            to={link} 
            className="text-amber-700 font-medium flex items-center transition-colors hover:text-amber-500"
          >
            Bắt đầu <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default GameCard; 